var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 36V6C48 4.4087 47.3679 2.88258 46.2426 1.75736C45.1174 0.632141 43.5913 0 42 0C40.4087 0 38.8826 0.632141 37.7574 1.75736C36.6321 2.88258 36 4.4087 36 6V36H6C4.4087 36 2.88258 36.6321 1.75736 37.7574C0.632141 38.8826 0 40.4087 0 42C0 43.5913 0.632141 45.1174 1.75736 46.2426C2.88258 47.3679 4.4087 48 6 48H36V78C36 79.5913 36.6321 81.1174 37.7574 82.2427C38.8826 83.3679 40.4087 84 42 84C43.5913 84 45.1174 83.3679 46.2426 82.2427C47.3679 81.1174 48 79.5913 48 78V48H78C79.5913 48 81.1174 47.3679 82.2426 46.2426C83.3679 45.1174 84 43.5913 84 42C84 40.4087 83.3679 38.8826 82.2426 37.7574C81.1174 36.6321 79.5913 36 78 36H48Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorNew);
export default __webpack_public_path__ + "static/media/vectorNew.c93c69ca.svg";
export { ForwardRef as ReactComponent };